import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import { Card } from 'react-bootstrap';

import UttamKalakarHeader from './UttamKalakarHeader';
import UttamKalakarFooter from './UttamKalakarFooter';

function ManuscriptPublished() {

    const [titlesList, setTitlesList] = useState([]);
    const [selectedTitle, setSelectedTitle] = useState('');
    const [loading, setLoading] = useState(false);

    // ✅ Fetch Titles
    useEffect(() => {
        axios.get('https://nrdruhs.in/api/getManuscriptsForPublish')
            .then((res) => {
         setTitlesList(res.data.titles || res.data);
         console.log("API RESPONSE:", res.data);
            })
            .catch((err) => {
                console.error(err);
            });
    }, []);

    // ✅ Publish Handler
    const handlePublish = async () => {

        if (!selectedTitle) {
            Swal.fire('Error', 'Please select a title', 'error');
            return;
        }

        const selectedArticle = titlesList.find(
            t => t.title === selectedTitle
        );

        if (!selectedArticle) {
            Swal.fire('Error', 'Invalid selection', 'error');
            return;
        }

        // 🔴 Block if already published
        if (selectedArticle.is_published === 1) {
            Swal.fire('Already Published', 'This article is already published', 'warning');
            return;
        }

        setLoading(true);

        try {
            await axios.post('https://nrdruhs.in/api/publishArticle', {
                articleid: selectedArticle.articleid
            });

            Swal.fire('Success', 'Article published successfully', 'success');

            // ✅ Update UI instantly
            setTitlesList(prev =>
                prev.map(item =>
                    item.articleid === selectedArticle.articleid
                        ? { ...item, is_published: 1 }
                        : item
                )
            );

            setSelectedTitle('');

        } catch (error) {
            console.error(error);

            const msg = error.response?.data?.error || 'Something went wrong';

            Swal.fire('Error', msg, 'error');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div>
            <UttamKalakarHeader />

            <div className="container" style={{ paddingTop: 45, paddingBottom: 45 }}>
                <h3 style={{ textAlign: 'center', padding: 30, fontWeight: 'bold' }}>
                    PUBLISH MANUSCRIPT
                </h3>

                {/* Dropdown */}
                <Card style={{ margin: '0 auto', maxWidth: 600 }}>
                    <Card.Body>
                        <select
                            className="form-select form-select-lg"
                            value={selectedTitle}
                            onChange={(e) => setSelectedTitle(e.target.value)}
                        >
                            <option value="">Select a title</option>

                            {titlesList.map((t) => {
                                const displayTitle = t.title.length > 66
                                    ? `${t.title.substring(0, 66)}...`
                                    : t.title;

                                return (
                                    <option
                                        key={t.articleid}
                                        value={t.title}
                                        disabled={t.is_published === 1}
                                    >
                                        {displayTitle} - {t.articleid} {t.is_published ? "✔ Published" : ""}
                                    </option>
                                );
                            })}
                        </select>
                    </Card.Body>
                </Card>

                {/* Button */}
                <div className="text-center mt-4" style={{ marginBottom: 60 }}>
                    <button
                        className="btn btn-success"
                        onClick={handlePublish}
                        disabled={loading}
                        style={{ fontSize: '20px', fontWeight: 'bold', padding: '10px 25px' }}
                    >
                        {loading ? 'Publishing...' : 'PUBLISH'}
                    </button>
                </div>
            </div>

            <UttamKalakarFooter />
        </div>
    );
}

export default ManuscriptPublished;